import { Link } from "react-router-dom";

export default function TermsOfService() {
  return (
    <>
      <section className="text-center py-5 bg-light px-4">
        <h2 className="text-uppercase fw-semibold text-primary small">
          Legal & Compliance
        </h2>
        <h1 className="mt-3 display-4 fw-bold text-dark">Terms of Service</h1>
        <p className="mt-3 text-secondary fs-5 w-75 mx-auto">
          By using Fieldsathi, you agree to abide by the following terms and
          conditions. Please read them carefully.
        </p>
      </section>

      <div className="container py-5 px-md-5 px-3">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <section className="mb-5">
              <h3 className="fw-bold text-dark">General Terms</h3>
              <p className="text-secondary fs-5">
                Fieldsathi is a service-oriented platform that connects users
                with professionals for field services. By using our platform,
                you agree to comply with all applicable laws and regulations.
              </p>
            </section>

            <section className="mb-5">
              <h4 className="fw-semibold text-dark">
                User Accounts & Responsibilities
              </h4>
              <p className="text-secondary">
                Users must maintain the confidentiality of their account
                credentials. Role-based access ensures authorized use of the
                platform’s functionalities.
              </p>
            </section>

            <section className="mb-5">
              <h4 className="fw-semibold text-dark">
                Service Use & Compliance
              </h4>
              <p className="text-secondary">
                Users agree to use Fieldsathi for lawful purposes. Fraudulent
                activities, unauthorized access, or misuse of services will
                result in immediate account termination.
              </p>
            </section>

            <section className="mb-5">
              <h4 className="fw-semibold text-dark">
                Privacy & Data Protection
              </h4>
              <p className="text-secondary">
                Fieldsathi is committed to protecting your privacy. All user
                data is securely stored and never shared without explicit
                consent. See our Privacy Policy for more details.
              </p>
            </section>
          </div>
        </div>
      </div>

      <div className="bg-light py-5 px-md-5 px-3">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <h3 className="fw-bold text-dark">Additional Legal Notices</h3>
              <div className="mt-4 border-start border-4 border-primary ps-4">
                <h5 className="text-uppercase text-primary fw-semibold">
                  Privacy Policy
                </h5>
                <p className="text-secondary">
                  Please review our{" "}
                  <Link href="/privacy-policy" className="text-primary">
                    Privacy Policy
                  </Link>
                  , which also governs your visit to our website, to understand
                  our practices regarding data collection and security.
                </p>
              </div>
              <div className="mt-4 border-start border-4 border-primary ps-4">
                <h5 className="text-uppercase text-primary fw-semibold">
                  Conditions of Use
                </h5>
                <p className="text-secondary">
                  By accessing Fieldsathi, you agree to adhere to our terms,
                  which outline permissible uses, account responsibilities, and
                  compliance measures.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
